import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "../../shared/store";
import { PersonalizedFertilizerPdpApp } from "./PersonalizedFertilizerPdpApp";
import type { PersonalizedFertilizerPdpConfig } from "./types";

function readConfig(configId: string): PersonalizedFertilizerPdpConfig {
  const configEl = document.getElementById(configId);

  if (!configEl?.textContent) {
    throw new Error(`Missing Personalized Fertilizer PDP config: ${configId}`);
  }

  return JSON.parse(configEl.textContent) as PersonalizedFertilizerPdpConfig;
}

document
  .querySelectorAll<HTMLElement>("[data-fertilizer-pdp-root]")
  .forEach((rootEl) => {
    if (rootEl.dataset.reactMounted === "true") return;

    const configId = rootEl.dataset.configId;
    if (!configId) return;

    rootEl.dataset.reactMounted = "true";

    createRoot(rootEl).render(
      <React.StrictMode>
        <Provider store={store}>
          <PersonalizedFertilizerPdpApp config={readConfig(configId)} />
        </Provider>
      </React.StrictMode>,
    );
  });
